export abstract class Model {
  public id!: string | number;

  constructor(data: any) {
    this.id = data.id;
  }

  // Must be overridden to guarantee correctly displayed names
  public abstract toString(): string;
}
